/**
 * Extract a user-friendly error message from an API error response.
 */
export function extractServiceFacilityApiError(
  error: unknown,
  fallback: string,
): string {
  if (error && typeof error === 'object') {
    // RTK Query error shape
    const rtkError = error as { data?: { detail?: string; message?: string } };
    if (rtkError.data?.detail) return rtkError.data.detail;
    if (rtkError.data?.message) return rtkError.data.message;
  }
  return fallback;
}
